import { render, staticRenderFns } from "./SunHeroSocialMediaRow.vue?vue&type=template&id=296f81f1&scoped=true"
import script from "./SunHeroSocialMediaRow.vue?vue&type=script&lang=js"
export * from "./SunHeroSocialMediaRow.vue?vue&type=script&lang=js"
import style0 from "./SunHeroSocialMediaRow.vue?vue&type=style&index=0&id=296f81f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296f81f1",
  null
  
)

export default component.exports